/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_All_DescInputs */



/**
* | output |
* | --- |
* | "Every meeting with participants, whoever is in it." |
*
* @param {Meetings_Kind_All_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_all_desc = /** @type {((inputs?: Meetings_Kind_All_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_All_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Elk gesprek met deelnemers, wie er ook bij is.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaque conversation avec des participants, peu importe qui en fait partie.")
	return /** @type {LocalizedString} */ ("Every meeting with participants, whoever is in it.")
});